<app-page-header header="agent-success.title" />

<qbe-panel-component class="success">
  <div class="success-container">
    <div class="success-summary">
      <h2 nxHeadline="section" class="success-headline">
        {{ 'success.title' | translate }}
      </h2>
      <p nxCopytext="normal" class="success-copy" [innerHTML]="
          ((isClientEmail$ | async)
            ? ('success.summary_remote' | translate : (clientEmail$ | async))
            : ((!(isForeigner$ | async) ? 'success.summary' : 'success.summary_foreigner') | translate : (summaryParams$ | async))
          ) | markdown
        "></p>
      <a [href]="policyPdf$ | async" (click)="handleDownloadPolicy()" target="_blank" nxButton="primary">
        <nx-icon class="nx-margin-right-2xs" name="download" nxIconPositionStart></nx-icon>{{ 'success.cta' | translate
        }}
      </a>
    </div>

    <section class="success-offer">
      <h4 nxHeadline="subsection-xsmall" class="success-headline">
        <b>
          {{ 'success.offer.title' | translate }}
        </b>
      </h4>
      <div [ngSwitch]="processKind$ | async">
        <div *ngSwitchCase="processType.RESIGNATION">
          <p nxCopytext="normal" class="success-copy">{{ 'success.offer.description-resignation' | translate }}</p>
        </div>
        <div *ngSwitchDefault>
          <p nxCopytext="normal" class="success-copy">{{ 'success.offer.description' | translate }}</p>
        </div>
      </div>
      <button (click)="handleOffer()" nxButton="tertiary" type="button">
        <nx-icon name="arrow-right" class="nx-margin-right-2xs"></nx-icon>
        {{ 'success.offer.cta' | translate }}
      </button>
      <figure class="success-illustration">
        <qbe-illustration name="womanCheeringInFrontOfComputer"></qbe-illustration>
      </figure>
    </section>
  </div>
</qbe-panel-component>